export default __webpack_public_path__ + "static/media/585_3.0a9874bf.jpg";